import i18n from '@/i18n'
import Layout from '../../companyAdmin/layout.vue'
import Index from './index.vue'
import RechargeList from './rechargeList.vue'

const baseUrl = '/v-admin/referral/client-admin/cash-management'

export default {
  path: `${baseUrl}/`,
  redirect: `${baseUrl}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_COMPANY_APPROVAL'],
    titleI18nKey: 'admin.company.cashPointsManagement.title.cashManagement',
    menu: {
      get label () {
        return i18n.t('admin.company.cashPointsManagement.menu.cashManagement')
      }
    }
  },
  children: [
    {
      path: `${baseUrl}/list`,
      component: Index,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.cashPointsManagement.title.cashManagement'
      }
    },
    {
      path: `${baseUrl}/:companyId/recharge-record`,
      component: RechargeList,
      meta: {
        isNewPage: true,
        titleI18nKey: 'admin.company.cashPointsManagement.title.rechargeRecord'
      }
    }
  ]
}
